<template>
  <div v-show="isShow.isKVShow" class="pageKV">
    <div class="fw1 fireworks1"></div>
    <div class="fw2 fireworks2"></div>
    <div class="fw3 fireworks3"></div>
    <div class="fw4 fireworks4"></div>
    <div class="kv_title">
      <div class="kv_title1 titleIn1"></div>
      <div class="kv_title2 titleIn2"></div>
    </div>
    <div class="kv_btn btnScale" @click="showNext"></div>
  </div>
</template>

<script>
export default {
  name: 'PageKV',
  props: {
    isShow: {
      type: Object
    }
  },
  methods: {
    showNext () {
      console.log('clicked')
      this.isShow.isKVShow = false
      this.isShow.isPOShow = true
      this.$emit('startAni')
    }
  }
}
</script>

<style lang="less" scoped>
.pageKV {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  background-image: url(./kv_bg.jpg);
  background-size: 100% 100%;
  .fw1 {
    position: absolute;
    top: 10%;
    left: 0;
    width: 4.6875rem /* 75/16 */;
    height: 5.9375rem /* 95/16 */;
    background-image: url(./kv_fw1.png);
    background-size: 100% 100%;
  }
  .fw2 {
    position: absolute;
    top: 0;
    right: 10%;
    width: 12.375rem /* 198/16 */;
    height: 9.6875rem /* 155/16 */;
    background-image: url(./kv_fw2.png);
    background-size: 100% 100%;
  }
  .fw3 {
    position: absolute;
    top: 20%;
    right: 60%;
    width: 6.4375rem /* 103/16 */;
    height: 6.5rem /* 104/16 */;
    background-image: url(./kv_fw3.png);
    background-size: 100% 100%;
  }
  .fw4 {
    position: absolute;
    top: 6%;
    right: 0;
    width: 5.3125rem /* 85/16 */;
    height: 7.8125rem /* 125/16 */;
    background-image: url(./kv_fw4.png);
    background-size: 100% 100%;
  }
  .kv_title {
    position: absolute;
    top: 26%;
    margin-top: -6.140625rem /* 98.25/16 */;
    width: 18.65625rem /* 298.5/16 */;
    height: 12.28125rem /* 196.5/16 */;
    .kv_title1 {
      width: 15.1875rem /* 243/16 */;
      height: 4.875rem /* 78/16 */;
      background-image: url(./kv_title1.png);
      background-size: 100% 100%;
    }
    .kv_title2 {
      margin-left: 3.125rem /* 50/16 */;
      width: 15.9375rem /* 255/16 */;
      height: 7.875rem /* 126/16 */;
      background-image: url(./kv_title2.png);
      background-size: 100% 100%;
    }
  }
  .kv_btn {
    position: absolute;
    bottom: 12%;
    width: 6.71875rem /* 107.5/16 */;
    height: 3.03125rem /* 48.5/16 */;
    background-image: url(./kv_btn.png);
    background-size: 100% 100%;
  }
}

.fireworks1 {
  animation: fireworks 1.2s linear;
}

.fireworks2 {
  animation: fireworks 1.2s linear;
  animation-delay: .2s;
}

.fireworks3 {
  animation: fireworks 1.2s linear;
  animation-delay: .8s;
}

.fireworks4 {
  animation: fireworks 1.2s linear;
}

@keyframes fireworks {
  0% {
    opacity: 0;
  }
  40% {
    transform: scale(.1) translateY(75rem /* 1200/16 */);
    transform-origin: center;
    opacity: .1;
  }
  70%, 100% {
    transform: scale(1) translateY(0);
    transform-origin: center;
    opacity: 1;
  }
}

.titleIn1 {
  animation: titleIn 1s ease-in;
}

.titleIn2 {
  animation: titleInR 1s ease-in;
}

@keyframes titleIn {
  0% {
    transform: translate3d(-18.75rem /* 300/16 */, 0, 0);
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
}

@keyframes titleInR {
  0% {
    transform: translate3d(18.75rem /* 300/16 */, 0, 0);
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
}

.btnScale {
  animation: btnScale 1.5s linear infinite;
}

@keyframes btnScale {
  0% {
    transform: scale(1);
  }
  70%, 100% {
    transform: scale(1.1);
  }
}
</style>
